import { Heading } from "components/Heading";
import { useTranslation } from "react-i18next";
import { Suspense } from "react";
import { FormSectionPlaceholder } from "components/FormSectionPlaceholder";
import { ManageInvitations } from "./ManageInvitations";
import { ContentWrapper } from "components/ContentWrapper";
import { HeadingWrapper } from "components/HeadingWrapper";

export const Container = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <HeadingWrapper>
        <Heading>{t("Team Invitations")}</Heading>
      </HeadingWrapper>
      <Suspense
        fallback={
          <>
            <FormSectionPlaceholder />
          </>
        }
      >
        <ManageInvitations />
      </Suspense>
    </ContentWrapper>
  );
};
